module.exports = __webpack_public_path__ + "static/media/34DSS4.65e1415b.jpg";